export default __webpack_public_path__ + "static/media/23.fd9a1075.png";